import { render } from "./CurrentClaims.vue?vue&type=template&id=b2c36d80"
import script from "./CurrentClaims.vue?vue&type=script&lang=js"
export * from "./CurrentClaims.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__